(function(){
  'use strict';

  var sortNavigationStarted = false;

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function normalizeInternalLinks(root){
    if (!isMobile()) return;
    (root || document).querySelectorAll('a[target="_blank"][href]').forEach(function(link){
      try {
        var url = new URL(link.getAttribute('href'), window.location.href);
        if ((url.protocol === 'http:' || url.protocol === 'https:') && url.origin === window.location.origin) {
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
      } catch(_) {}
    });
  }

  function translateExactText(root){
    var footerTitles = {
      'Information': 'Información',
      'Quick links': 'Enlaces',
      'Payment methods': 'Métodos de pago',
      'Follow Us': 'Síguenos'
    };

    (root || document).querySelectorAll('.footer .widget-title .txt_title, .footer-top .widget-title .txt_title').forEach(function(el){
      var text = (el.textContent || '').trim();
      if (footerTitles[text]) el.textContent = footerTitles[text];
    });

    (root || document).querySelectorAll('label.text-label').forEach(function(el){
      if ((el.textContent || '').trim() === 'Remember me') el.textContent = 'Recordarme';
    });
  }

  function preventDecorativePaymentJumps(root){
    (root || document).querySelectorAll('.footer .list-payment a[href="#"]').forEach(function(link){
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
      link.addEventListener('click', function(e){ e.preventDefault(); }, {once:false});
    });
  }

  function goToCollectionSort(value){
    if (!value || sortNavigationStarted) return;
    sortNavigationStarted = true;

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    } catch(_) {
      window.location.assign(window.location.pathname + '?sort_by=' + encodeURIComponent(value));
    }
  }

  function handleSortSelect(event){
    var select = event.target;
    if (!select || !select.matches) return;

    var isKnownSort = select.matches('#SortBy, #SortBy-mobile');
    var isNamedSort = select.matches('select[name="sort_by"]');
    if (!isKnownSort && !isNamedSort) return;
    if (!select.value) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    goToCollectionSort(select.value);
  }

  document.addEventListener('click', function(event){
    var target = event.target;
    var link = target && target.closest ? target.closest('.js_ajaxsortby a[data-erectus-sort]') : null;
    if (!link) return;

    var value = link.getAttribute('data-erectus-sort');
    if (!value) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    goToCollectionSort(value);
  }, true);

  document.addEventListener('input', handleSortSelect, true);
  document.addEventListener('change', handleSortSelect, true);

  function addStyles(){
    if (document.getElementById('erectus-site-polish-styles')) return;
    var style = document.createElement('style');
    style.id = 'erectus-site-polish-styles';
    style.textContent = [
      '@media (max-width:767px){',
      '.footer .main-footer{padding-top:24px!important;padding-bottom:18px!important;}',
      '.footer .widget-title{font-size:14px!important;line-height:1.3!important;margin-bottom:10px!important;}',
      '.footer .widget_footer,.footer .textwidget{font-size:12.5px!important;line-height:1.5!important;}',
      '.footer .footer-note{padding-top:12px!important;padding-bottom:72px!important;}',
      '.footer .coppy-right .content{font-size:11px!important;line-height:1.4!important;text-align:center!important;}',
      '.apus-footer-mobile{z-index:90!important;}',
      '.apus-footer-mobile ul li a{min-height:52px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function run(root){
    addStyles();
    normalizeInternalLinks(root || document);
    translateExactText(root || document);
    preventDecorativePaymentJumps(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  } else {
    run(document);
  }
  document.addEventListener('shopify:section:load', function(e){ run(e.target || document); });
})();
